/** @deprecate
 * Este componente fue remplazado por ../DatePicker
 */

import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import Button from '../Button/Button';
import { subDays, format } from 'date-fns';
import './Datepicker.scss';
import { ReactComponent as IconCalendar } from '../../assets/images/icons-hoy-16-px.svg';
import {
  Body,
  Buttons,
  ButtonsRight,
  Footer,
  DateInput,
} from './Datepicker.styles';
import Span from '../Texts/Span/Span';
import es from 'date-fns/locale/es';
import OutsideAlerter from '../OutsideAlerter/OutsideAlerter';
registerLocale('es', es);

const Datepicker_DEPRECATED = (props) => {
  const [clickedOutsideTrigger, setClickedOutsideTrigger] = useState();
  const [fltersModified, setFiltersModified] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    if (props.initialValues) {
      props.initialValues.startDate &&
        setStartDate(createDate(props.initialValues.startDate));
      props.initialValues.endDate &&
        setEndDate(createDate(props.initialValues.endDate));
    }
  }, [props.initialValues]);

  useEffect(() => {
    fltersModified && clearCalendar();
  }, [clickedOutsideTrigger]);

  let calendarRef = React.createRef();

  const calendarContainer = ({ children }) => {
    setClickedOutsideTrigger(false);
    return (
      <div>
        <Body>{children}</Body>
        <Footer>
          <Buttons>
            <Button variant='link' size='sm' onClick={onReset}>
              Limpiar
            </Button>
            <ButtonsRight>
              <Button variant='secondary' size='sm' onClick={onCancel}>
                Cancelar
              </Button>
              <Button variant='primary' size='sm' onClick={onAccept}>
                Aplicar
              </Button>
            </ButtonsRight>
          </Buttons>
        </Footer>
      </div>
    );
  };

  //input: 'yyyy-MM-dd'
  //output: Date
  const createDate = (date) => {
    return new Date(Date.parse(date + 'T00:00-03:00'));
  };

  const onChange = (dates) => {
    setFiltersModified(true);
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const onAccept = () => {
    setFiltersModified(false);
    calendarRef.current.setOpen(false);

    if (props.onAccept) {
      props.onAccept(outputFormatDate(startDate), outputFormatDate(endDate));
      props.onSubmit();
    }
  };

  const onCancel = () => {
    let finalDateStart = props.start
      ? setStartDate(createDate(props.start))
      : null;
    let finalDateEnd = props.end ? setStartDate(createDate(props.end)) : null;

    setStartDate(finalDateStart);
    setEndDate(finalDateEnd);

    calendarRef.current.setOpen(false);
  };

  const onReset = () => {
    clearCalendar();
  };

  const clearCalendar = () => {
    setEndDate(null);
    setStartDate(null);
  };

  const outputFormatDate = (date) =>
    date && props.outputFormat ? format(date, props.outputFormat) : '';

  const CustomDateInput = ({ onClick, start, end, placeholder }) => {
    let dateFormat = props.dateFormat
      ? typeof props.dateFormat === 'function'
        ? props.dateFormat(start, end)
        : props.dateFormat
      : 'dd/MM/yyyy';

    let startFormatted = start ? format(start, dateFormat) + ' - ' : '';
    let endFormatted = end ? format(end, dateFormat) : '';

    let place = startFormatted || endFormatted;

    return (
      <DateInput onClick={onClick}>
        {place ? (
          <span>{startFormatted + endFormatted}</span>
        ) : (
          <Span type='2' variant='disabled'>
            {placeholder}
          </Span>
        )}
        <IconCalendar />
      </DateInput>
    );
  };

  return (
    <div
      data-testid='datepicker'
      className={`datepicker ${
        props.showMonthYearPicker ? 'monthYearPicker' : ''
      }`}
    >
      <OutsideAlerter
        handleOutSideClick={() =>
          setClickedOutsideTrigger(!clickedOutsideTrigger)
        }
      >
        <DatePicker
          selected={null}
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          shouldCloseOnSelect={false}
          monthsShown={props.monthsShown}
          ref={calendarRef}
          maxDate={props.maxDate}
          minDate={props.minDate}
          openToDate={startDate ? startDate : subDays(new Date(), 30)}
          placeholderText={props.placeholder}
          formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
          calendarContainer={calendarContainer}
          locale='es'
          showMonthYearPicker={props.showMonthYearPicker}
          customInput={
            props.customInput ? (
              props.customInput
            ) : (
              <CustomDateInput
                start={startDate}
                end={endDate}
                placeholder={props.placeholder}
                onClick={props.onClick}
              />
            )
          }
        />
      </OutsideAlerter>
    </div>
  );
};

export default Datepicker_DEPRECATED;
